module.exports = __webpack_public_path__ + "img/11.788f73d8.png";